import * as models from '@app/models';
import { Button } from '@material-ui/core';
import React from 'react';
import Icon from './icon.component';
import { MaerskPagination } from './maersk-pagination';

const TablePaginationComponent: React.FunctionComponent<models.ITablePaginationProps> = (props) => {
	const siblingCount = !!props.siblingCount ? props.siblingCount : 3;
	return (
		<MaerskPagination
			activePage={props.page}
			totalPages={props.totalPages}
			onRenderBoundaryEllipsis={(defaultClassName, defaultText) => (
				<Button variant='text' className={defaultClassName} disabled={true}>
					{defaultText}
				</Button>
			)}
			onRenderNextButton={(defaultClassName, isDisabled, defaultText) => (
				<Button
					variant='text'
					endIcon={<Icon name='chevron-right' />}
					disabled={isDisabled}
					onClick={(e) => props.onChangePage(null, props.page + 1)}
					className={defaultClassName}
				>
					{defaultText}
				</Button>
			)}
			onRenderPreviousButton={(defaultClassName, isDisabled, defaultText) => (
				<Button
					variant='text'
					startIcon={<Icon name='chevron-left' />}
					disabled={isDisabled}
					onClick={(e) => props.onChangePage(null, props.page - 1)}
					className={defaultClassName}
				>
					{defaultText}
				</Button>
			)}
			onRenderPageButton={(defaultClassName, pageNumber) => (
				<Button variant='text' className={defaultClassName} onClick={(e) => props.onChangePage(e, pageNumber)}>
					{pageNumber}
				</Button>
			)}
			siblingCount={siblingCount}
		/>
	);
};

TablePaginationComponent.defaultProps = {
	showPaginator: true,
	showRecordCount: true,
	showPageLabel: true,
};

export default TablePaginationComponent;



// WEBPACK FOOTER //
// ./src/components/shared/table-pagination.component.tsx